module.exports = __webpack_public_path__ + "static/media/farmer-circle-white.1f493efd.svg";